import React from "react";
import "../less/index";
import FilesForDownload from "../../../../auxiliary-components/shared/FilesForDownload/views/file.c";
import DOMPurify from 'utils/sanitize';
import UsageBlock from "../../../../auxiliary-components/shared/UsageBlock";
import usage_block_data from "../enums/usage_block_data.json";
import usage_block_data_2 from "../enums/usage_block_data_2.json";
import Banner from "../../../../auxiliary-components/shared/Banner";

export default function template() {
  const isMobile = this.isViewportMobile(),
    page = "sunny-tariff",
    filesForDownload = {
      data: [
        {
          title_ua: this.l10n("ACQUIRING_LEFT_DOC_TITLE"),
          name_ua: this.l10n("SUNNY_TARIFF_DOC_TEXT"),
          image_path: "/api/v1/media/img?path=PDF.png",
          link_path_ua: "/static/business/sunny_tariff_rules.pdf"
        }
      ]
    };

  return (
    <div className="sunny-tariff-module">
      <Banner
        text={"SUNNY_TARIFF_BANNER_SUBTITLE"}
        textMob={"SUNNY_TARIFF_BANNER_SUBTITLE_MOB"}
        title={"SUNNY_TARIFF_BANNER_TITLE"}
        page={page}
        isMobile={isMobile}
        dates={"SUNNY_TARIFF_BANNER_DATES"}
      ></Banner>
      <div className="content">
        <UsageBlock
          isMobile={isMobile}
          page={page}
          data={usage_block_data}
          className="col-2-row-2"
        ></UsageBlock>
        <UsageBlock
          isMobile={isMobile}
          page={page}
          data={usage_block_data_2}
          className="col-2-row-2"
        ></UsageBlock>
        <div className="title">{this.l10n("SUNNY_TARIFF_HOW_TO_TITLE")}</div>
        <div className="how-to-block">
          <div className="how-to-block-desc">{this.l10n("SUNNY_TARIFF_HOW_TO_SUBTITLE")}</div>
          <ul className="how-to-block-list">
            <li className="how-to-block-list-item">{this.l10n("SUNNY_TARIFF_HOW_TO_TEXT_1")}</li>
            <li className="how-to-block-list-item">{this.l10n("SUNNY_TARIFF_HOW_TO_TEXT_2")}</li>
            <li className="how-to-block-list-item">{this.l10n("SUNNY_TARIFF_HOW_TO_TEXT_3")}</li>
          </ul>
        </div>
        <div className="title">{this.l10n("SUNNY_TARIFF_HOW_TO_TITLE_2")}</div>
        <div className="text"
             dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n("SUNNY_TARIFF_HOW_TO_TEXT_4")) }}></div>
        <div className="text"
             dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n("SUNNY_TARIFF_HOW_TO_TEXT_5")) }}></div>
        <FilesForDownload lang={this.props.lang} widget={filesForDownload} />
      </div>
    </div>
  );
}
